"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spreadSelector = exports.level2SellSelector = exports.level2Selector = exports.level2BuySelector = exports.convertLevel2SideDataToCurrency = void 0;
var _reselect = require("reselect");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _numberFormatter = require("../../helpers/numberFormatter");
var _orderHelper = require("../../helpers/orderHelper");
var _orderHistorySelectors = require("./orderHistorySelectors");
var _instrumentPositionSelectors = require("./instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var convertLevel2SideDataToCurrency = exports.convertLevel2SideDataToCurrency = function convertLevel2SideDataToCurrency() {
  return function (data, instrument, orders) {
    if (!instrument) {
      return data;
    }
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var uniqOrders = (0, _orderHelper.mergeOpenOrders)(orders);
    var userOrders = uniqOrders.map(function (order) {
      var quantity = (0, _numberFormatter.currency)(order.DisplayQuantity, Product1Symbol);
      return _objectSpread(_objectSpread({}, order), {}, {
        Quantity: quantity,
        MySize: order.Quantity
      });
    });
    var level2Orders = data.reduce(function (acc, order) {
      if (order.ProductPairCode !== instrument.InstrumentId) return acc;
      var price = (0, _numberFormatter.currency)(order.Price, Product2Symbol);
      var quantity = (0, _numberFormatter.currency)(order.Quantity, Product1Symbol);
      var userOrderIndex = userOrders.findIndex(function (item) {
        return item.Price.isEqualTo(price);
      });
      if (userOrderIndex !== -1) {
        var result = _objectSpread(_objectSpread({}, userOrders[userOrderIndex]), {}, {
          Quantity: quantity,
          MySize: userOrders[userOrderIndex].Quantity
        });
        userOrders.splice(userOrderIndex, 1);
        acc.push(result);
        return acc;
      }
      acc.push(_objectSpread(_objectSpread({}, order), {}, {
        Price: price,
        Quantity: quantity
      }));
      return acc;
    }, []);
    return level2Orders.sort(function (a, b) {
      return b.Price.minus(a.Price);
    });
  };
};
var level2BuySelector = exports.level2BuySelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.level2.buy;
}, _instrumentPositionSelectors.selectedInstrumentSelector, _orderHistorySelectors.buyOpenOrdersSelector], convertLevel2SideDataToCurrency());
var level2SellSelector = exports.level2SellSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.level2.sell;
}, _instrumentPositionSelectors.selectedInstrumentSelector, _orderHistorySelectors.sellOpenOrdersSelector], convertLevel2SideDataToCurrency());
var level2Selector = exports.level2Selector = (0, _reselect.createSelector)([level2BuySelector, level2SellSelector], function (buy, sell) {
  return {
    buy: buy,
    sell: sell
  };
});
var spreadSelector = exports.spreadSelector = (0, _reselect.createSelector)([level2BuySelector, level2SellSelector], function (buy, sell) {
  var bestBuy = buy.reduce(function (acc, i) {
    if (i.Price.gt(acc)) return i.Price;
    return acc;
  }, 0);
  var bestSell = sell.reduce(function (acc, i) {
    if (i.Price.lt(acc)) return i.Price;
    return acc;
  }, Infinity);
  if (bestSell !== Infinity) {
    return bestSell.minus(bestBuy);
  }
  if (bestBuy !== 0) {
    return bestBuy.times(-1);
  }
  return new _bignumber["default"](0);
});